import * as React from "react"
import {useEffect} from "react"
import {useDeepCompareEffect} from "react-use";
import {appConfig, appUser, haveConfig} from "../@signals";
import {mergeDicts} from "@ui-seeker/utils";
import {batch} from "@preact/signals-react";
import {useLocation} from "react-router-dom";
import {useTheme} from "@mui/material";


let didInit = false;
let showLog = false

export default function AppLayout({ baseConfig, config, userData, onSetConfig, children, isLocal=false }) {
    const location = useLocation();
    const theme = useTheme()

    useEffect(() => {
        if (!didInit) batch(() => {
            didInit = true
            const myConfig = mergeDicts(baseConfig, config)
            onSetConfig && onSetConfig(myConfig)
            appConfig.value = myConfig
        })
    }, []);

    useEffect(() => {
        if (isLocal && !showLog) {
            console.log('%cTip: you can access the documentation "theme" object directly in the console', 'color: green; font-size: 16px; font-weight: bold;')
            window.theme = theme
            showLog = true
        }
    }, [theme])

    useDeepCompareEffect(() => {
        appUser.value = userData
    }, [userData])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    if (!haveConfig.value) return <></>

    return <>
        {children}
    </>
}